import Footer from "@/components/Footer";
import Blogs from "@/components/Home/Blogs";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import Image from "next/image";
import React from "react";
import { useRouter } from "next/router";

import { storefront } from "@/helpers/store";
import { useSingleArticle } from "@/hooks/blogs";
import Loading from "@/components/Loading";

const BlogPost = ({ article }) => {
  const router = useRouter();
  // const { article, isLoading } = useSingleArticle(router.query.slug);

  // if (isLoading) return <Loading />;

  if (!article) return "Something Went Wrong! Please Refresh The Page";

  console.log(article);

  return (
    <>
      <SEO title={article?.title} />

      <Layout>
        {/* blog post start */}

        <div className="px-4 w-full h-auto py-8 space-y-8">
          <h1 className="text-3xl lg:text-5xl font-semibold text-[#294870]">
            {article?.title}
          </h1>
          <div className="flex items-center space-x-2">
            <svg
              width={19}
              height={23}
              viewBox="0 0 29 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.00918 1.17511C9.00918 0.526114 8.48306 0 7.83407 0C7.18508 0 6.65896 0.526114 6.65896 1.17511V3.52533H6.26725C2.80594 3.52533 0 6.33127 0 9.79258V10.9677H28.2026V9.79258C28.2026 6.33127 25.3966 3.52533 21.9354 3.52533H21.5437V1.17511C21.5437 0.526114 21.0175 0 20.3686 0C19.7196 0 19.1935 0.526114 19.1935 1.17511V3.52533H9.00918V1.17511ZM0 13.3179H28.2026V26.2441C28.2026 29.7054 25.3966 32.5114 21.9354 32.5114H6.26725C2.80594 32.5114 0 29.7054 0 26.2441V13.3179ZM14.1013 23.1105C14.9666 23.1105 15.6681 22.409 15.6681 21.5437C15.6681 20.6783 14.9666 19.9769 14.1013 19.9769C13.236 19.9769 12.5345 20.6783 12.5345 21.5437C12.5345 22.409 13.236 23.1105 14.1013 23.1105ZM21.9354 21.5437C21.9354 22.409 21.2339 23.1105 20.3686 23.1105C19.5032 23.1105 18.8018 22.409 18.8018 21.5437C18.8018 20.6783 19.5032 19.9769 20.3686 19.9769C21.2339 19.9769 21.9354 20.6783 21.9354 21.5437ZM7.83407 23.1105C8.69939 23.1105 9.40088 22.409 9.40088 21.5437C9.40088 20.6783 8.69939 19.9769 7.83407 19.9769C6.96875 19.9769 6.26725 20.6783 6.26725 21.5437C6.26725 22.409 6.96875 23.1105 7.83407 23.1105Z"
                fill="#6F6F6F"
              />
            </svg>

            <p className="text-sm text-[#6F6F6F]">
              {article?.publishedAt?.slice(0, 10)}
            </p>
          </div>

          {/* warning */}
          <p className="text-[#6F6F6F] text-sm">{/* here warning */}</p>

          <div className="relative w-full h-[300px] lg:h-[600px] ">
            <Image
              className="rounded-3xl"
              fill
              objectFit="contain"
              src={article?.image?.originalSrc}
            />
          </div>

          {/* post details */}

          <div className="">
            <div
              className="dangerousHTML"
              dangerouslySetInnerHTML={{
                __html: article?.contentHtml,
              }}
            />
          </div>

          {/* socila emdia share */}
          <div className="flex items-center space-x-4">
            <div className="cursor-pointer flex items-center space-x-2">
              <svg
                width={20}
                height={21}
                viewBox="0 0 26 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.6933 0.241211H5.17333C2.31618 0.241211 0 2.55739 0 5.41454V20.9345C0 23.7916 2.31618 26.1078 5.17333 26.1078H10.9933V18.3479H6.46666V14.4679H10.9933V11.8812C10.9933 9.02405 13.3095 6.70787 16.1666 6.70787H19.4V10.5879H16.1666C15.4523 10.5879 14.8733 11.1669 14.8733 11.8812V14.4679H19.4V18.3479H14.8733V26.1078H20.6933C23.5504 26.1078 25.8666 23.7916 25.8666 20.9345V5.41454C25.8666 2.55739 23.5504 0.241211 20.6933 0.241211Z"
                  fill="#294870"
                />
              </svg>
              <p className="text-[#294870] text-sm font-light">Share</p>
            </div>

            <div className="cursor-pointer flex items-center space-x-2">
              <svg
                width={20}
                height={17}
                viewBox="0 0 25 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.9078 0.883057C14.1666 0.883057 11.9444 3.21643 11.9444 6.09478C11.9444 6.52973 11.9951 6.95223 12.0908 7.35613C9.45502 7.35613 5.48503 6.82323 2.16945 3.50144C1.72856 3.05972 0.91557 3.35506 0.946151 3.97839C1.43752 13.9941 5.72689 16.9155 7.93579 17.0973C6.50941 18.5061 4.43742 19.618 2.35245 20.1172C1.80219 20.2489 1.66626 20.8513 2.20432 21.0263C3.69622 21.5115 5.83163 21.6984 6.98107 21.73C15.1125 21.73 21.7215 14.8858 21.8686 6.38441C22.9362 5.69016 23.62 4.18273 24.0042 3.11486C24.0978 2.85478 23.6716 2.55176 23.4163 2.65799C22.6189 2.99 21.6064 3.06871 20.744 2.7877C19.8337 1.62477 18.4532 0.883057 16.9078 0.883057Z"
                  fill="#28303F"
                />
              </svg>

              <p className="text-sm">Tweet</p>
            </div>

            <div className="cursor-pointer flex items-center space-x-2">
              <svg
                width={21}
                height={21}
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26.6782 13.1745C26.6782 20.3173 20.8877 26.1078 13.7448 26.1078C12.6699 26.1078 11.6256 25.9767 10.6271 25.7295L10.633 25.7079L12.0266 20.4115C12.5788 20.5421 13.1542 20.6112 13.7448 20.6112C17.8519 20.6112 21.1815 17.2816 21.1815 13.1745C21.1815 9.06737 17.8519 5.73787 13.7448 5.73787C9.63768 5.73787 6.30818 9.06737 6.30818 13.1745C6.30818 14.5275 6.67035 15.7987 7.30367 16.8935C7.57191 17.3573 8.16529 17.5157 8.62902 17.2475C9.09273 16.9793 9.25119 16.3859 8.98295 15.9222C8.51584 15.1147 8.24818 14.1774 8.24818 13.1745C8.24818 10.1388 10.7091 7.67787 13.7448 7.67787C16.7806 7.67787 19.2415 10.1388 19.2415 13.1745C19.2415 16.2102 16.7806 18.6712 13.7448 18.6712C13.3233 18.6712 12.9136 18.6239 12.5205 18.5346L14.036 12.7747C14.1723 12.2566 13.8628 11.7261 13.3447 11.5898C12.8267 11.4535 12.2962 11.763 12.1599 12.281L8.78142 25.1212C4.1018 23.1747 0.811523 18.5589 0.811523 13.1745C0.811523 6.03165 6.60196 0.241211 13.7448 0.241211C20.8877 0.241211 26.6782 6.03165 26.6782 13.1745Z"
                  fill="#28303F"
                />
              </svg>

              <p className="text-sm">Pin it</p>
            </div>
          </div>
          {/* social media end */}
        </div>

        {/* blog post end */}

        <Blogs />
      </Layout>

      <Footer />
    </>
  );
};

export default BlogPost;

export async function getStaticPaths() {
  const { data } = await storefront(`
    query {
      blogByHandle(handle: "news") {
        articles(first: 250) {
          edges {
            node {
              handle
            }
          }
        }
      }
    }
  `);

  return {
    paths: data.blogByHandle.articles.edges.map(({ node }) => ({
      params: { slug: node.handle },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  try {
    const title = params.slug; // Assuming the slug parameter represents the product title
    const query = `
    query  {
      blogByHandle(handle: "news") {
        articles(first: 1, query: "${title}") {
          edges {
            node {
              id
              title
              contentHtml
              excerptHtml
              publishedAt
              blog {
                handle
              }
              image {
                id
                originalSrc
                altText
              }
            }
          }
        }
      }
    }
    `;

    const response = await storefront(query);

    if (response.errors) {
      console.error(response.errors);
      return {
        notFound: true,
      };
    }

    const article = response.data.blogByHandle.articles.edges[0]?.node;

    if (!article) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        article,
      },
      revalidate: 60, // Regenerate every 60 seconds (adjust as needed)
    };
  } catch (error) {
    console.error(error);
    return {
      notFound: true,
    };
  }
}
